module.exports = {
  siteTitle: 'Automekano',
  siteDescription: 'Distribuidor autorizado en el Ecuador de las marcas: DFSK, King Long, UD Trucks, JCB y Weichai',
  pathPrefix: '/',
  author: `guaguamedia.com`,
  siteUrlProd: process.env.DOMAIN,
  siteUrlLocal: `https://localhost:8000`,
}
